var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.banner)?_c('div',{staticClass:"verification"},[_c('div',{staticClass:"banner"},[(_vm.banner.action === 'verification')?_c('router-link',{attrs:{"to":{
        name: 'Profile',
        params: { target: _vm.banner.action },
      }}},[_c('p',[_vm._v(_vm._s(_vm.banner.text))])]):_c('router-link',{attrs:{"to":{
        name: 'Profile',
        params: { target: null },
      }}},[_c('p',[_vm._v(_vm._s(_vm.banner.text))])])],1),(_vm.banner)?_c('div',{staticClass:"banner-protection"}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }